import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "@tanstack/react-router";
import { FileQuestion, Loader2 } from "lucide-react";
import { EmptyState } from "../components/ui/card";
import { Editor } from "../editor/Editor";
import { orpc } from "../lib/api";
import { useOrgId } from "../lib/org";

/** Full-screen design editor for one file. */
export function DocumentPage() {
  const orgId = useOrgId();
  const { documentId } = useParams({ strict: false }) as { documentId: string };
  const document = useQuery({
    ...orpc.documents.get.queryOptions({ input: { orgId, documentId } }),
    // The editor owns the content after loading; no background refetches.
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  if (document.isError) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <EmptyState
          icon={<FileQuestion />}
          title="Datei nicht gefunden"
          description="Sie wurde gelöscht oder du hast keinen Zugriff."
          action={
            <Link to="/o/$orgId" params={{ orgId }} className="text-sm font-medium text-brand-600">
              Zu den Projekten
            </Link>
          }
        />
      </div>
    );
  }
  if (!document.data) {
    return (
      <div className="flex h-full items-center justify-center text-zinc-400">
        <Loader2 className="size-6 animate-spin" />
      </div>
    );
  }
  return <Editor key={document.data.id} orgId={orgId} document={document.data} />;
}
